// extracted by mini-css-extract-plugin
module.exports = {"header":"page-header_header__0pd4J","title":"page-header_title__3W9oH"};